import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

class RegulationPage extends Component {
	render() {
		return (
			<div>
				<p>Texto do regulamento</p>
			</div>
		)
	}
}

const connectedRegulationPage = withRouter(connect(null)(RegulationPage))
export { connectedRegulationPage as ModuleRootComponent }
